<template>
    <div class="wrap">

        <br>
        <br>
        <br>
        <div class="row">
            <div class="col text-center">
            <i class="bi bi-send-x luna-color" style="font-size: 200px;"></i>
            </div>
        </div>
        <br>
        <br>
        <div class="row">
            <div class="col text-center luna-color">
                みてねを送る上限に達しています。
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col text-center">
                <a href="/search">さがすページへ</a>
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    data() {
        return {
        };
    },
}
</script>